import React from 'react';

const PROVIDER = {
  AWS: { bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200', label: 'AWS' },
  Azure: { bg: 'bg-sky-50', text: 'text-sky-700', border: 'border-sky-200', label: 'Azure' },
  GCP: { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200', label: 'GCP' },
};

const FRAMEWORK = {
  'SOC 2': { bg: 'bg-indigo-50', text: 'text-indigo-700', border: 'border-indigo-200' },
  'ISO 27001': { bg: 'bg-violet-50', text: 'text-violet-700', border: 'border-violet-200' },
  'DORA': { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200' },
  'PCI DSS': { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  'PII': { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
};

export function ProviderBadge({ provider = 'AWS', className = '' }) {
  const cfg = PROVIDER[provider] ?? PROVIDER.AWS;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-mono font-semibold rounded border ${cfg.bg} ${cfg.text} ${cfg.border} ${className}`}>
      {cfg.label}
    </span>
  );
}

export function FrameworkBadge({ framework = 'SOC 2', className = '' }) {
  const cfg = FRAMEWORK[framework] ?? { bg: 'bg-slate-100', text: 'text-slate-700', border: 'border-slate-200' };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-semibold rounded border ${cfg.bg} ${cfg.text} ${cfg.border} ${className}`}>
      {framework}
    </span>
  );
}
